import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ToolbarButton } from '../models/toolbar-button.model';

@Injectable()
export class ToolbarService {
  public buttons: Observable<ToolbarButton[]>;
  private buttonsSubject: BehaviorSubject<ToolbarButton[]>;
  public extra: Observable<TemplateRef<any>>;
  private extraSubject: BehaviorSubject<TemplateRef<any>>;

  constructor() {
    this.buttonsSubject = new BehaviorSubject<ToolbarButton[]>([]);
    this.buttons = this.buttonsSubject.asObservable();
    this.extraSubject = new BehaviorSubject<TemplateRef<any>>(null);
    this.extra = this.extraSubject.asObservable();
  }

  public get buttonsValue(): ToolbarButton[] {
    return this.buttonsSubject.value;
  }

  updateButtons(buttons: ToolbarButton[]): void {
    this.buttonsSubject.next(buttons);
  }

  public get extraValue(): TemplateRef<any> {
    return this.extraSubject.value;
  }

  updateExtra(content: TemplateRef<any>): void {
    this.extraSubject.next(content);
  }

}
